export const FETCH_LOAD_PROJECT_REQUEST = 'FETCH_LOAD_PROJECT_REQUEST'
export const FETCH_LOAD_PROJECT_SUCCESS = 'FETCH_LOAD_PROJECT_SUCCESS'
export const FETCH_LOAD_PROJECT_FALUIRE = 'FETCH_LOAD_PROJECT_FALUIRE'
